module.exports = __webpack_public_path__ + "static/media/37.95f8e0a6.jpg";